import { keyframes } from '@emotion/react';
import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';
import { LazyLoadingImgState } from './LazyLoadingImg.state';
import { useAppStateContext } from 'src/AppState/AppState';

type ImageFitType = 'fill' | 'cover' | 'scale-down' | 'none';

interface ImageType {
    allowShow: boolean,
    imgFit?: ImageFitType
}

export const progress = keyframes`
    0% {
    transform: translateX(-50%);
  }

  100% {
    transform: translateX(300%);
  }
`;

const Image = styled('img', { label: 'Image' })<ImageType>`
    position: absolute;
    top: 0;
    left: 0;
    object-fit: ${({ imgFit }): string => imgFit !== undefined ? imgFit : 'cover'};
    width: 100%;
    height: 100%;
    opacity: ${({ allowShow }): string => allowShow ? '1' : '0'};
    transition: opacity 0.3s ease-in-out;
`;

interface ImageWrapperPropsType {
    isLoaded: boolean;
}

const ImageWrapper = styled('div', { label: 'ImageWrapper' })<ImageWrapperPropsType>`
    position: relative;
    &::before{
        background: linear-gradient(35deg, rgba(224,224,224,0.2) 0%, rgba(244,244,244,0.6) 100%);
        content: '';
        opacity: ${({ isLoaded }): string => isLoaded ? '0' : '1'};
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        visibility: ${({ isLoaded }): string => isLoaded ? 'hidden' : 'visible'};
        transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
    }
`;

interface LazyLoadingImgPropsType {
    imgSrc: string
    className?: string
    onClick?: () => void
    alt?: string
    imgFit?: ImageFitType
}

export const LazyLoadingImg = observer('LazyLoadingImg', (props: LazyLoadingImgPropsType) => {
    const appState = useAppStateContext();
    const { session } = appState;
    const [state] = React.useState(() => new LazyLoadingImgState(props.imgSrc, session.isBrowser()));
    const alt = props.alt !== undefined ? `Game ${props.alt}` : '';

    React.useEffect(() => {
        state.observe();
        return (): void => state.unobserve();
    }, []);

    return (
        <ImageWrapper className={props.className} onClick={props.onClick} isLoaded={state.allowShow}>
            <Image
                ref={state.setImgRef}
                decoding='async'
                src={state.imgForView}
                onLoad={state.onLoad}
                allowShow={state.allowShow}
                alt={alt}
                imgFit={props.imgFit}
            >
            </Image>
        </ImageWrapper>
    );
});
